export const environment = {
  production: false,
  name: 'dev',
  apiBaseUrl: 'https://dev.ccmsapi.carescertification.com/api',
};
